import { LeaveTypeForm, LeaveTypeListTable } from "./component";

import { useLeaveTypeSettings } from "@hooks/HRM/leave/useLeaveTypeSettings";

export const LeaveSettingsBody = () => {
  const data = useLeaveTypeSettings();

  return (
    <>
      <LeaveTypeForm data={data} />
      <LeaveTypeListTable data={data} />
    </>
  );
};
